module.exports = __webpack_public_path__ + "img/change_login_pwd.53aa8060.svg";